<template>
  <div v-if="message" class="smardie-field-error" role="alert">
    <i class="attention icon" aria-hidden="true"></i>
    <span class="smardie-field-error__text">{{ message }}</span>
  </div>
</template>

<script>
export default {
  name: 'FieldError',
  props: {
    message: {
      type: String,
      default: ''
    }
  }
}
</script>
